<div
  class="h-screen bg-cover relative"
  style="background-image:url(assets/images/background-splash.png)"
>
  <div class="relative z-mg h-full w-full flex items-center justify-center px-16">
    <section class="text-white text-center max-w-640">
      <div>
          <h1>
            <div class="w-140 mx-auto">
              <app-logo [reverse]="true"></app-logo>
            </div>
            <span class='sr-only'>Iowa Code Camp</span>
            <span class="block py-48 text-white font-sans text-60 md:text-104">
              10.26.24
            </span>
          </h1>
        <div class="mb-32">
          <p>
            <strong>DMACC, Ankeny</strong> | For software developers interested in industry-specific topics, such as front-end JavaScript frameworks,  IT cloud infrastructure, database architecture, and working with engineering teams
          </p>
        </div>
        <div class="flex gap-20 justify-center items-center mx-auto max-w-640">
          <div class="w-140">
            <a
              class="block border-2 text-center rounded-8 px-16 py-8 rounded transition w-full bg-red-orange border-transparent"
              [href]="registerLink"
              target="_blank"
              >
              <span class="strong text-white whitespace-nowrap">Register</span>
            </a>
          </div>
          <!-- <div class="w-180">
            <a
              class="block border-2 text-center rounded-8 px-16 py-8 rounded transition w-full bg-transparent border-white"
              [href]="speakersLink"
              target="_blank"
              >
              <span class="strong text-white whitespace-nowrap">Call for Speakers</span>
            </a>
          </div> -->
        </div>
      </div>
    </section>
  </div>
  <div class="bg-black opacity-60 inset-0 absolute z-bg"></div>
</div>
